import styles from "./PreviewGameCourt.module.css";

const PreviewGameCourtStyles = {
    live_game_section: `relative rounded-[10px] overflow-hidden w-full min-h-[316px] flex items-center justify-center ${styles.live_game_section}
                        screen-500:bg-themeShadowColor
    `,
    headerSection: `flex justify-between items-center gap-[5px] absolute ${styles.headerSection}`,
    complexNameSection: `flex justify-between items-center gap-[5px] absolute bottom-2 left-0 ${styles.headerSection}
                    screen-500:right-2 screen-500:left-[unset]
    `,
    liveContainer: `flex gap-2 items-center rounded-full px-3 py-1 h-[24px] bg-liveColor ${styles.liveContainer}`,
    liveIndicator: `rounded-full bg-liveGameText h-[8px] w-[8px] animate-pulse ${styles.liveIndicator}`,
    replayedIndicator: `rounded-full bg-[#B98B00] h-[8px] w-[8px] animate-pulse ${styles.liveIndicator}`,
    endedContainer: `flex gap-2 items-center rounded-full px-3 py-1 border border-red-500 bg-themeColor`,
    replayedContainer: `flex gap-2 items-center rounded-full px-3 py-1 border border-[#B98B00] bg-themeColor`,
    endedIndicator: `rounded-full bg-red-500 h-[10px] w-[10px] animate-pulse`,
    gameText:`text-[10px] font-[500] text-liveGameText animate-pulse
              md:text-[12px] ${styles.gameText}
    `,
    complexName: `uppercase text-[18px] text-liveGamePrimaryColor ${styles.complexName}`,
    image: `w-full h-[auto] max-w-[17px] ${styles.image}`,
    back_btn: `p-2 flex items-center justify-center rounded-[6px] bg-liveGameBackground shadow-previewLiveGameBoxShadow absolute top-2 left-0
               screen-500:hidden
    `,
    expand_btn: `p-2 flex items-center justify-center rounded-[6px] bg-liveGameBackground shadow-previewLiveGameBoxShadow absolute top-2 left-10
               screen-500:hidden
    `,
    mobile_score_display_design: `absolute top-2 right-0 flex
                                  screen-500:hidden
    `,
    open_leaderboard: `absolute right-0 bottom-2 w-[44px] h-[44px] min-w-[44px] min-h-[44px] bg-liveGameBackground shadow-previewLiveGameBoxShadow rounded-full flex items-center justify-center
                       screen-500:hidden
    `
  };
  
  export { PreviewGameCourtStyles };
  